<template>
  <div class="logout">
    <h1>Logging out ...</h1>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  mounted() {
    //  https://auth-server/auth/realms/%7Brealm-name%7D/protocol/openid-connect/logout?redirect_uri=encodedRedirectUri
    const authServerUrl = process.env.VUE_APP_KEY_CLOAK_AUTH_SERVER_URL
    const realm = process.env.VUE_APP_KEY_CLOAK_REALM
    const clientId = process.env.VUE_APP_KEY_CLOAK_RESOURCE
    const hostHref = window.location.href
    const hostArr = hostHref.split('/')
    const hostUrl = hostArr[0] + '//' + hostArr[2]
    const url = `${authServerUrl}/realms/${realm}/protocol/openid-connect/logout?client_id=${clientId}&post_logout_redirect_uri=${window.location.origin}`
    console.log('url is ' + url)
    window.location.href = url
  },
}
</script>
